import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { useUser } from "../utils/UserContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChartSimple} from '@fortawesome/free-solid-svg-icons'
import TradingViewWidget from "../components/TradingViewWidget";
import TradeForm from "../components/TradeForm";
import { useLocation } from "react-router-dom";
import { toast } from 'react-hot-toast';

function Trade() {
  const { user } = useUser();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const symbol = queryParams.get("symbol");
  const tradetype = queryParams.get("tradetype");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [crypto, setCrypto] = useState([]);
  const [fiat, setFiat] = useState([]);
  const [stock, setStock] = useState([]);
  const [wallet, setWallet] = useState([]);
  const [assethistory, setAssethistory] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchwallet: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setWallet(data.wallet);
      }
    })
    .catch(err => {
      toast.error('Error fetching deposit transaction!')
    })
  }, [user]);
  useEffect(() => {
      fetch(`/coin_list.txt`)
      .then((res) => res.json())
      .then((data) => {
      var coinList = data.data;
      const updatedData = coinList.map((coin, index) => ({
          id: index + 1,
          logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
          name: coin.name,
          type: 'crypto',
          symbol: coin.symbol,
          price: Number(coin.quote.USD.price.toFixed(2)),
          amount: 0,
      }));
      setCrypto(updatedData);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    fetch(`/stock_list.txt`)
    .then((res) => res.json())
    .then((data) => {
    const stockList = Object.values(data);
    const updatedData = stockList.map((stock, index) => ({
        id: index + 1,
        logo: `https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`,
        name: stock.name,
        type: 'stock',
        symbol: stock.symbol,
        price: Number(stock.price.toFixed(2)),
        amount: 0,
    }));
    setStock(updatedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {   
      fetch(`/fiat_list.txt`)
      .then((res) => res.json())
      .then((data) => {
        const wantedCurrencies = {
          AUD: 'Australian Dollar',
          CAD: 'Canadian Dollar',
          CHF: 'Swiss Franc',
          CNY: 'Chinese Yuan',
          EUR: 'Euro',
          GBP: 'British Pound',
          INR: 'Indian Rupee',
          JPY: 'Japanese Yen',
          RUB: 'Russian Ruble',
          USD: 'US Dollar',
          ZAR: 'South African Rand'
        };
        const fiatList = Object.entries(data)
          .filter(([code]) => wantedCurrencies.hasOwnProperty(code))
          .map(([code, value], index) => ({
            id: index + 1,
            symbol: code,
            name: wantedCurrencies[code],
            price: Number(value),
            type: 'fiat',
            logo: `https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`,
            amount: 0,
          }));
        
        setFiat(fiatList);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    if (!crypto.length && !fiat.length && !stock.length) return;
    const walletMap = wallet.reduce((acc, item) => {
      const key = item.coinName?.trim().toLowerCase();
      acc[key] = parseFloat(item.balance) || 0;
      return acc;
    }, {});
    const applyWalletBalance = (list) =>
      list.map(item => {
        const key = item.name?.trim().toLowerCase();
        const matchedBalance = walletMap[key];
        return {
          ...item,
          amount: matchedBalance || 0
        };
      });
    const merged = [
      ...applyWalletBalance(crypto),
      ...applyWalletBalance(fiat),
      ...applyWalletBalance(stock)
    ];
    const sorted = merged.sort((a, b) => {
      if (b.amount > 0 && a.amount === 0) return 1;
      if (a.amount > 0 && b.amount === 0) return -1;
      return a.name.localeCompare(b.name);
    });
    setAssethistory(sorted);
  }, [crypto, fiat, stock, wallet]);
  const [type, setType] = useState(tradetype?tradetype:'crypto');
  const [trade, setTrade] = useState(symbol ? symbol : type === "crypto" ? "BTC" : type === "forex" ? "AAPL" : "EUR");
  const [activeTab, setActiveTab] = useState("open")
  const [openTrades, setOpenTrades] = useState([]);
  const [closedTrades, setClosedTrades] = useState([]);  
  const [swapTrades, setSwapTrades] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchtrade: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        const openTrades = [];
        const closedTrades = [];
        const swapTrades = [];
        data.trades.forEach(trade => {
          if (trade.details === "Running" && trade.action !== "Swap") {
            openTrades.push(trade);
          } else if(trade.action === "Swap") {
            swapTrades.push(trade);
          }else{
            closedTrades.push(trade);
          }
        });
        setOpenTrades(openTrades);
        setClosedTrades(closedTrades);
        setSwapTrades(swapTrades);
      }else{
        toast.error(data.message);
      }
    })
    .catch(err => {
      toast.error('Error fetching trade data!')
    })
  }, [user]);  
  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Trade" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Trade" icon={<FontAwesomeIcon icon={faChartSimple} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row">
              <div className="col-lg-8 col-12">
                <div className="mycard p-2 mt-2">
                  <TradingViewWidget symbol={trade} type={type} />
                </div>
              </div>
              <div className="col-lg-4 col-12">
                <TradeForm trade={trade} setTrade={setTrade} type={type} setType={setType}/>
              </div>
              <div className="col-12">
                <div className="mycard mt-2" style={{minHeight: '450px'}}>
                  <div className="d-flex align-items-center mb-4">
                    <h6 className="mb-0 text-white me-3" style={{fontSize: '18px'}}>Trades</h6>
                    <div className="mytab">
                      <div className={`mytab-item ${activeTab === "open" ? 'active' : ''}`} onClick={() => {
                        setActiveTab("open")}}>Open</div>
                      <div className={`mytab-item ${activeTab === "closed" ? 'active' : ''}`} onClick={() => {
                        setActiveTab("closed")}}>Closed</div>
                      <div className={`mytab-item ${activeTab === "swap" ? 'active' : ''}`} onClick={() => {
                        setActiveTab("swap")}}>Swaps</div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    {activeTab === "open" && (
                    <table className="table table-borderless table-dark align-middle">
                      <thead>
                        <tr className="fs-7">
                          <th className="fw-normal text-light" style={{width: '150px'}}>Trade ID</th>
                          <th className="fw-normal text-light" style={{width: '150px'}}>Date</th>
                          <th className="fw-normal text-light">Type</th>
                          <th className="fw-normal text-light">Trade</th>
                          <th className="fw-normal text-light">Direction</th>
                          <th className="fw-normal text-light">Amount</th>
                          <th className="fw-normal text-light text-nowrap">Entry Price</th>
                          <th className="fw-normal text-light text-nowrap">Stop Loss</th>
                          <th className="fw-normal text-light text-nowrap">Take Profit</th>
                          <th className="fw-normal text-light text-nowrap">Time Frame</th>
                          <th className="fw-normal text-light text-nowrap">Leverage</th>
                          <th className="fw-normal text-light">Profit</th>
                          <th className="fw-normal text-light">Action</th>
                        </tr>
                      </thead>
                      <tbody style={{fontSize: '14px'}}>
                        {openTrades.length > 0 && openTrades.map((trade, index) => (
                          <tr key={index}>
                            <td>{trade.trade_id}</td>
                            <td>{trade.trade_time}</td>
                            <td>{trade.type}</td>
                            <td>{trade.pair}</td>
                            <td>{trade.action}</td>
                            <td>{trade.amount}</td>
                            <td>{trade.entry}</td>
                            <td>{trade.sl}</td>
                            <td>{trade.tp}</td>
                            <td>{trade.tf}</td>
                            <td>{trade.leverage}X</td>
                            <td>{trade.result}</td>
                            <td className="text-warning">{trade.details}</td>
                          </tr>
                        ))}
                        {openTrades.length === 0 && (
                          <tr>
                            <td colSpan={5}>No Open trades yet.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    )}
                    {activeTab === "closed" && (
                    <table className="table table-borderless table-dark align-middle">
                      <thead>
                        <tr className="fs-7">
                        <th className="fw-normal text-light" style={{width: '150px'}}>Trade ID</th>
                          <th className="fw-normal text-light" style={{width: '150px'}}>Date</th>
                          <th className="fw-normal text-light">Type</th>
                          <th className="fw-normal text-light">Trade</th>
                          <th className="fw-normal text-light">Direction</th>
                          <th className="fw-normal text-light">Amount</th>
                          <th className="fw-normal text-light text-nowrap">Entry Price</th>
                          <th className="fw-normal text-light text-nowrap">Stop Loss</th>
                          <th className="fw-normal text-light text-nowrap">Take Profit</th>
                          <th className="fw-normal text-light text-nowrap">Time Frame</th>
                          <th className="fw-normal text-light text-nowrap">Leverage</th>
                          <th className="fw-normal text-light">Profit</th>
                          <th className="fw-normal text-light">Action</th>
                        </tr>
                      </thead>
                      <tbody style={{fontSize: '14px'}}>
                        {closedTrades.length > 0 && closedTrades.map((trade, index) => (
                          <tr key={index}>
                            <td>{trade.trade_id}</td>
                            <td>{trade.trade_time}</td>
                            <td>{trade.type}</td>
                            <td>{trade.pair}</td>
                            <td>{trade.action}</td>
                            <td>{trade.amount}</td>
                            <td>{trade.entry}</td>
                            <td>{trade.sl}</td>
                            <td>{trade.tp}</td>
                            <td>{trade.tf}</td>
                            <td>{trade.leverage}X</td>
                            <td>{trade.result}</td>
                            <td className={`${trade.details === 'Loss' ? 'text-danger' : 'text-success'}`}>{trade.details}</td>
                          </tr>
                        ))}
                        {closedTrades.length === 0 && (
                          <tr>
                            <td colSpan={5}>No Closed trades yet.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    )}
                    {activeTab === "swap" && (
                    <table className="table table-borderless table-dark align-middle">
                      <thead>
                        <tr className="fs-7">
                          <th className="fw-normal text-light">Date</th>
                          <th className="fw-normal text-light">Trade</th>
                          <th className="fw-normal text-light">Direction</th>
                          <th className="fw-normal text-light">Amount</th>
                          <th className="fw-normal text-light">Status</th>
                        </tr>
                      </thead>
                      <tbody style={{fontSize: '14px'}}>
                        {swapTrades.length > 0 && swapTrades.map((trade, index) => {
                          // PUT THE CODE HERE - inside the map function
                          const baseSymbol = trade.pair.includes('/') 
                          ? trade.pair.split('/')[0] 
                          : trade.pair;
                          const tradeasset = assethistory.find(item => item.symbol === baseSymbol);
                          return (
                            <tr key={index}>
                                <td>{trade.trade_time}</td>
                              <td>
                                <img src={tradeasset.logo} alt={tradeasset.symbol} style={{width: '30px'}}/>
                                <span className="fw-bold ms-3">{trade.pair}</span> 
                                <span className="ms-2 px-2 py-1 rounded-pill text-prime" style={{backgroundColor: '#ff6b3520',fontSize:'12px'}}>Swap</span> 
                              </td>
                              <td>{trade.action}</td>
                              <td>{parseFloat(trade.amount).toFixed(6)} {baseSymbol}</td>
                              <td>
                                <div className={`myBtn d-inline-block bg-success`}>Success</div>
                              </td>
                            </tr>
                          );
                        })}
                        {swapTrades.length === 0 && (
                          <tr>
                            <td colSpan={5}>No Swap trades yet.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Trade